export default "__VITE_ASSET__Y$rWBeeZ__";